module.exports = __webpack_public_path__ + "static/img/samsungwelstory.44a2f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/samsungwelstory.jpg
// module id = 1Z5a
// module chunks = 0